import { Instance, SnapshotIn, SnapshotOut, types } from "mobx-state-tree"

export const PortModel = types.model("Port").props({
  id: types.number,
  name: types.string,
})

export type Port = Instance<typeof PortModel>
export type SearchOrigin = Instance<typeof PortModel>
export type SearchDestination = Instance<typeof PortModel>

export type PortSnapshotOut = SnapshotOut<typeof PortModel>
export type PortSnapshotIn = SnapshotIn<typeof PortModel>
